import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { LayoutDashboard, Users, Search, CalendarClock, CalendarDays, MessageSquare, CheckSquare, BarChart2, Settings, LogOut } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { GROWTHLY_LOGO_URL } from '../../constants/branding';
export function SideNav() {
  const {
    user,
    logout
  } = useAuth();
  const navigate = useNavigate();
  const navItems = [{
    to: '/app/dashboard',
    icon: LayoutDashboard,
    label: 'Dashboard'
  }, {
    to: '/app/leads',
    icon: Users,
    label: 'Leads'
  }, {
    to: '/app/enriquecimiento',
    icon: Search,
    label: 'Enriquecimiento'
  }, {
    to: '/app/calendario',
    icon: CalendarDays,
    label: 'Calendario'
  }, {
    to: '/app/cadencias',
    icon: CalendarClock,
    label: 'Cadencias'
  }, {
    to: '/app/campanas',
    icon: MessageSquare,
    label: 'Campañas'
  }, {
    to: '/app/qa',
    icon: CheckSquare,
    label: 'QA'
  }, {
    to: '/app/reportes',
    icon: BarChart2,
    label: 'Reportes'
  }, {
    to: '/app/config',
    icon: Settings,
    label: 'Configuración'
  }];
  const handleLogout = () => {
    logout();
    navigate('/login', {
      replace: true
    });
  };
  const initials = user?.name ? user.name.split(' ').slice(0, 2).map(s => s[0]).join('').toUpperCase() : '··';
  return <aside className="hidden md:flex fixed left-0 top-0 h-screen w-[260px] flex-col bg-growthly-surface border-r border-white/[0.04] z-30" data-id="element-247">
      <div className="px-6 py-5 border-b border-white/[0.04]" data-id="element-248">
        <div className="bg-white rounded-[10px] px-4 py-3 flex items-center justify-center" data-id="element-249">
          <img src={GROWTHLY_LOGO_URL} alt="Growthly" className="h-7 w-auto object-contain" data-id="element-250" />
        </div>
        <p className="text-[11px] text-growthly-muted mt-2.5 text-center tracking-wide" data-id="element-251">
          Corporation Systems
        </p>
      </div>

      <nav className="flex-1 px-3 py-4 space-y-1 overflow-y-auto" data-id="element-252">
        {navItems.map(({
        to,
        icon: Icon,
        label
      }) => <NavLink key={to} to={to} className={({
        isActive
      }) => `flex items-center gap-3 px-3 h-10 rounded-lg text-[14px] transition-colors ${isActive ? 'bg-white text-[#0B0B0B] font-medium' : 'text-growthly-text-2 hover:bg-white/[0.03] hover:text-white'}`} data-id="element-253">
            <Icon size={18} strokeWidth={1.8} data-id="element-254" />
            {label}
          </NavLink>)}
      </nav>

      <div className="p-3 border-t border-white/[0.04]" data-id="element-255">
        <div className="flex items-center gap-3 px-3 py-2.5 rounded-lg bg-white/[0.02]" data-id="element-256">
          <div className="w-9 h-9 rounded-full bg-gradient-to-br from-[#27AE60] to-[#1d8048] flex items-center justify-center text-white text-[12px] font-semibold flex-shrink-0" data-id="element-257">
            {initials}
          </div>
          <div className="flex-1 min-w-0" data-id="element-258">
            <p className="text-[13px] font-medium text-white truncate" data-id="element-259">
              {user?.name ?? 'Ivana Jovanoska Risteska'}
            </p>
            <p className="text-[11px] text-growthly-muted truncate" data-id="element-260">
              {user?.role ?? 'Marketing Manager'}
            </p>
          </div>
          <button onClick={handleLogout} aria-label="Cerrar sesión" className="w-8 h-8 rounded-md flex items-center justify-center text-growthly-muted hover:text-white hover:bg-white/[0.05] transition-colors flex-shrink-0" data-id="element-261">
            <LogOut size={15} strokeWidth={1.8} data-id="element-262" />
          </button>
        </div>
      </div>
    </aside>;
}